import CartAddress from "./CartAddress";

const CartConfirmationDelivery = ({ completedOrder }) => {


    const deliveryVia = completedOrder.DeliveryViaRule.id;
    const deliveryText = deliveryVia === 'D' ? "Delivering to " : "Collection for ";
    const deliveryLoc = completedOrder.C_BPartner_Location_ID;
    const message = deliveryText + deliveryLoc.Name;

    return (
        <div>
            <p className="cart-h">{message}</p>
            <CartAddress address={deliveryLoc.C_Location_ID} />
        </div>
    )
}

export default CartConfirmationDelivery;
